var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"to":"/login","text":"","color":"grey darken-3"}},[_c('v-icon',[_vm._v("mdi-account-circle-outline")]),_c('span',{staticClass:"ml-2"},[_vm._v("Log in")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }